import { ZOLL_ONLINE } from '@/constants';
import { container } from '@/container';
import { Connection } from '@/services/Connection';
import { Environment } from '@/services/Environment';
import { RouterGuard } from '@/services/router/types';
import { pathJoin } from '@/utils/pathJoin';

/**
 * Ensure user is authenticated.
 */
export const authenticationGuard: RouterGuard = async function authenticationGuard(to, from, next) {
  const connection = await container.getAsync(Connection);
  const environment = await container.getAsync(Environment);

  if (!connection.success) {
    window.location.replace(pathJoin(environment.zoBaseUrl, ZOLL_ONLINE.LOGIN_PATH));
    next(false);
  }
  else {
    next();
  }
};
